/* ══════════════════════════════════════════════════════════════════════════
   LA SU — The third-party popups, the one script
   Loaded from snippets/lasu-head.liquid, deferred, beside lasu-popups.css.
   docs/decisions.md, 2026-10-01.

   Any link to #cookie-einstellungen reopens the Cookiebot banner, so a
   visitor can change or withdraw consent later, as easily as they gave it.
   The merchant adds it as a menu item in Onlineshop → Navigation, e.g. in
   the footer's Rechtliches menu. The name is theirs; the link is
   #cookie-einstellungen, or /#cookie-einstellungen. It works in any menu,
   on any page.

   Cookiebot.renew() is Cookiebot's own call for this. Cookiebot comes from
   GTM, which the theme editor skips, and an ad blocker can stop it. Without
   it, the link opens the privacy policy instead of doing nothing; with no
   policy set either, it does nothing at all.
   ══════════════════════════════════════════════════════════════════════════ */

(() => {
  // Read while this script runs: document.currentScript is null afterwards.
  const privacyUrl = document.currentScript?.dataset.privacyUrl || '';

  document.addEventListener('click', (event) => {
    // A modified click opens a new tab or window. Leave it to the browser.
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('a[href*="#cookie-einstellungen"]');
    if (!link || new URL(link.href).hash !== '#cookie-einstellungen') return;

    if (typeof window.Cookiebot?.renew === 'function') {
      event.preventDefault();
      window.Cookiebot.renew();
    } else if (privacyUrl) {
      event.preventDefault();
      window.location.assign(privacyUrl);
    }
  });
})();
